import { createSlice } from "@reduxjs/toolkit";
import {
  getBlocks,
  addNewBlock,
  updateBlock,
  deleteBlock,
  getBlockById,
  getBlockUnitsById,
} from "./thunk";

export const initialState = {
  blocks: [],
  blockUnits: [],
  error: null,
  selectedBlock: null,
  isBlockSuccess: false,
  isBlockCreated: false,
};

const blocksSlice = createSlice({
  name: "BlocksSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch blocks
    builder.addCase(getBlocks.fulfilled, (state, action) => {
      state.blocks = action.payload; // Assuming `action.payload` contains block data
      state.isBlockSuccess = true;
      state.error = null;
    });

    builder.addCase(getBlocks.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch blocks";
      state.isBlockSuccess = false;
    });

    // Fetch a single block by ID
    builder.addCase(getBlockById.fulfilled, (state, action) => {
      state.selectedBlock = action.payload; // Set the selected block
      state.error = null;
    });

    builder.addCase(getBlockById.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch block by ID";
      state.selectedBlock = null; // Clear the selected block on failure
    });

    // Fetch a block units by ID
    builder.addCase(getBlockUnitsById.fulfilled, (state, action) => {
      state.blockUnits = action.payload; // Set the selected block
      state.error = null;
    });

    builder.addCase(getBlockUnitsById.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch block by ID";
      // state.selectedBlock = null; // Clear the selected block on failure
    });

    // Add new block
    builder.addCase(addNewBlock.fulfilled, (state, action) => {
      state.blocks.push(action.payload); // Add the new block to the list
      state.isBlockCreated = true;
      state.error = null;
    });

    builder.addCase(addNewBlock.rejected, (state, action) => {
      state.error = action.payload || "Failed to add block";
      state.isBlockCreated = false;
    });

    // Update block
    builder.addCase(updateBlock.fulfilled, (state, action) => {
      state.blocks = state.blocks.map((block) =>
        block.id === action.payload.id ? { ...block, ...action.payload } : block
      );
      state.error = null;
    });


    builder.addCase(updateBlock.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to update block";
    });

    // Delete block
    builder.addCase(deleteBlock.fulfilled, (state, action) => {
      state.blocks = state.blocks.filter(
        (block) => block.id !== action.payload.blockId
      );
      state.error = null;
    });

    builder.addCase(deleteBlock.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to delete block";
    });
  },
});

export default blocksSlice.reducer;
